import * as React from "react";
import CountDown from "../CountDown";
import { BannerWrapper } from "./styled";
export var CardType;
(function (CardType) {
    CardType["Single"] = "Single";
    CardType["Normal"] = "Normal";
})(CardType || (CardType = {}));
export const BannerContainer = (props) => {
    const { imgWidth = "", imgHeight = "", type = CardType.Normal, banner, ltImg, rtImg, countdownToEnd = "0", placeholderBg = "", } = props;
    return (React.createElement(BannerWrapper, { uiType: type, style: {
            width: imgWidth,
            height: imgHeight,
            background: `url(${placeholderBg}) center`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
        } },
        ltImg && React.createElement("img", { className: "ltImg", src: ltImg }),
        rtImg && React.createElement("img", { className: "rtImg", src: rtImg }),
        +countdownToEnd > 0 && (React.createElement("div", { className: "countdown" },
            React.createElement(CountDown, { countTime: countdownToEnd, style: {
                    borderRadius: type === CardType.Single ? "0 0 0 6px" : undefined,
                }, needIcon: type !== CardType.Single }))),
        React.createElement("img", { className: "mainImg", src: banner })));
};
